export default class MemberUtils {
  static mapMember(memberIn) {
    let computedMemberId = null;
    if ('member_id' in memberIn) {
      computedMemberId = memberIn.member_id;
    } else if ('followee_member_id' in memberIn) {
      computedMemberId = memberIn.followee_member_id;
    }
    return {
      memberId: computedMemberId,
      cognitoUsername: memberIn.aws_cognito_sub,
      birthDate: memberIn.birth_date,
      emailAddress: memberIn.email_address,
      gender: memberIn.gender,
      height: memberIn.height,
      weight: memberIn.weight,
      firstName: memberIn.first_name,
      lastName: memberIn.last_name,
      memberType: memberIn.member_type,
      showFolloweeRealName: memberIn.show_followee_real_name,
      accessLevel: memberIn.access_level,
      garminOauthToken: memberIn.garmin_oauth_token,
      suuntoAuthToken: memberIn.suunto_auth_token,
      suuntoV2OauthToken: memberIn.suunto_v2_oauth_token,
      teams: memberIn.teams,
      polarOauthToken: memberIn.polar_oauth_token,
      prefersMetric: memberIn.prefers_metric,
    };
  }
}
